// extracted by mini-css-extract-plugin
export var helpdesk__image = "helpdesk-module--helpdesk__image--qlV2e";
export var helpdesk__imageWrapper = "helpdesk-module--helpdesk__image-wrapper--+zCRq";
export var helpdesk__gradient = "helpdesk-module--helpdesk__gradient--KUZ-7";
export var helpdesk__gradient_tablet = "helpdesk-module--helpdesk__gradient_tablet--GGu+k";
export var helpdesk__gradient_mobile = "helpdesk-module--helpdesk__gradient_mobile--JfXN3";
export var helpdesk__gradient_top = "helpdesk-module--helpdesk__gradient_top--lNRJ8";
export var helpdesk__gradient_bottom = "helpdesk-module--helpdesk__gradient_bottom--ah4SS";